module.exports = __webpack_public_path__ + "img/headerLogo.4b519bd6.png";